import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { Outlet, useNavigate } from 'react-router-dom';
import React from 'react';

function Auth0ProviderLayout() {
    const navigate = useNavigate();

    const domain = import.meta.env.VITE_AUTH0_DOMAIN;
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
    const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL;
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

    const onRedirectCallback = (appState?: AppState) => {
        navigate(appState?.returnTo || '/callback');
    };

    if (!(domain && clientId && redirectUri && audience)) {
        console.error('Auth0 environment variables are not defined:', {
            domain,
            clientId,
            redirectUri,
            audience,
        });
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <h1>Auth0 Configuration Missing</h1>
                <p>
                    The Auth0 environment variables are not properly configured.
                </p>
                <p>
                    Please check your .env file and ensure the VITE_ prefixed
                    variables are defined.
                </p>
                <p>
                    Missing variables: {!domain && 'VITE_AUTH0_DOMAIN, '}
                    {!clientId && 'VITE_AUTH0_CLIENT_ID, '}
                    {!redirectUri && 'VITE_AUTH0_CALLBACK_URL, '}
                    {!audience && 'VITE_AUTH0_AUDIENCE'}
                </p>
            </div>
        );
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                audience,
                redirect_uri: redirectUri,
            }}
            useCookiesForTransactions
            onRedirectCallback={onRedirectCallback}
        >
            <Outlet />
        </Auth0Provider>
    );
}

export default Auth0ProviderLayout;
